export var DEPLOY_DATE = new Date('2026-04-09T20:39:56+0000');
